
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class SkeletonBox extends Vue {
  @Prop({ default: false, type: Boolean })
  readonly rounded!: boolean
}
